<template>
    <div class="animated fadeIn">
        <transactions-filter v-model="request" />        
        <carousel :perPage="1">
          <slide class="p-1">
            <b-card>
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <div class="callout callout-success">
                      <small class="text-muted">
                      Total
                      <br />Vendas Bruto
                      </small>
                      <h4 class="h4">{{totalSales}}</h4>
                  </div>
                </div>
              </div>
            </b-card>
          </slide>
          <slide class="p-1">
            <b-card>
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <div class="callout callout-success">
                      <small class="text-muted">
                      Total
                      <br />Vendas Líquido
                      </small>
                      <h4 class="h4">{{totalSeller}}</h4>
                  </div>
                </div>
              </div>
            </b-card>
          </slide>
        </carousel>
        <balance-summary />
        <b-card>
            <b-table
              :items="result.data"
              :fields="fields"
              :striped="true"              
              thead-class="hidden_header"
              :bordered="false"
              :borderless="true"
            >         
               <template #cell(row-details)="data">
                <table class="table-transaction-item" style="height:100% important!;border:solid 0px;background-color: none !important;" width="100%" cellpadding="0">
                    <tr>
                      <td width="42"><img :src="data.item.paymentMethodImage" :alt="data.item.paymentMethodName"></td>
                      <td>
                        {{formatDateTimeFields(data.item.date)}}
                        <br />
                        {{data.item.paymentMethodFormatted}}
                      </td>
                      <td>                       
                          {{formatDecimalFields(data.item.grossAmount)}}
                          <br />
                          {{formatDecimalFields(data.item.netAmount)}}
                      </td>
                    </tr>
                  </table>
               </template>     
            </b-table>
            <nav>
              <b-pagination
                :total-rows="result.rowCount"
                :per-page.sync="result.pageSize"
                v-model="currentPage"
                prev-text="‹"
                next-text="›"
                @change="pageIndexChanged"
                first-text="«"
                last-text="»"
                align="center"
              />
            </nav>
        </b-card>
    </div>
</template>
<script>
import moment from 'moment';
import transactionService from "../../services/Transactions/transactionService";
import TransactionsFilter from './TransactionsFilter.vue';
import reportPage from './reportPage';
import BalanceSummary from '../../components/balance/summary.vue';
import config from '../../config';
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: "report-transactions",
  inheritAttrs: false,
  mixins: [reportPage],
  components: {    
    TransactionsFilter,
    BalanceSummary,
    Carousel,
    Slide
  },
  data: function () {
    return {
      actionUri: 'reports/transaction',      
      summaryResult: this.getEmptySummaryResult(),
      currentPage: 1
    };
  },
  computed: {
    totalAcquirer(){
      return this.summaryResult.totalAcquirer.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalSales(){
      return this.summaryResult.totalSales.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalPartner(){
      return this.summaryResult.totalPartner.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalSalesPerson(){
      return this.summaryResult.totalSalesPerson.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalSeller(){
      return this.summaryResult.totalSeller.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalPlatform(){
      return this.summaryResult.totalPlatform.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
  },
  created() {
    this.fetchData(1);
    this.fetchSummaryData();
  },
  methods: {
    getEmptySummaryResult() {
      return {
        totalAcquirer: 0,
        totalSales: 0,
        totalPartner: 0,
        totalSalesPerson: 0,
        totalSeller: 0,
        totalPlatform: 0,
      };
    },
    fetchSummaryData() {
      const self = this;
      this.showLoading();
      transactionService
        .summary(
          this.getRequestParams()
        )
        .then(
          (response) => {                        
            self.summaryResult.totalSales = response.data.totalSales;            
            self.summaryResult.totalSeller = response.data.totalSeller;
            
            self.hideLoading();
          },
          () => {
            self.summaryResult = self.getEmptySummaryResult();
            self.hideLoading();
          }
        );
      
    },
    fetchData(page) {      
      const self = this;
      this.showLoading();
      transactionService
        .findAll(
          this.getRequestParams(),
          page
        )
        .then(
          (response) => {
            if(response.status == 204) {
              self.result = self.getEmptyResult()
            }
            else {
              self.result.data = response.data.data
              let transaction = {}
              for(let i = 0; i <= self.result.data.length - 1; i++) {
                transaction = self.result.data[i]
                transaction.transactionId = transaction.id
                
                transaction.paymentMethodFormatted = `${transaction.paymentMethodTypeName} (${transaction.installmentCount}x)`
                transaction.nuPartnerFeeFormatted = `${transaction.fee.toLocaleString('pt-BR', { style: 'decimal' })}% | ${transaction.feeAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`                                                              
              }
              self.result.pageIndex = page
              self.result.rowCount = response.data.total
              self.result.pageSize = 5
            }            
            self.hideLoading();
          },
          () => {
            self.result = self.getEmptyResult();
            self.hideLoading();
          }
        );
    },  
    pageIndexChanged(page) {
      this.currentPage = page;
      this.fetchData(page);
    },
    formatDateTimeFields(value) {
      return value == null || value == '' ? '' : moment(value).format('DD/MM/YYYY - HH:mm:ss');
    },
    formatDecimalFields(value) {
      return value == null || value == '' ? 'R$ 0,00' : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.hidden_header {
  display: none;
}
.table-transaction-item{
  font-size: 11px;
  width: 100%;
}


.table-transaction-item td{
  padding: 0.25rem !important;
  text-align: left;
  vertical-align: middle !important;
}

.table-transaction-item td:last-child{
  text-align: right !important;
}

.table-transaction-item tr {
  background: none !important;
}
.table-transaction-item tr:nth-of-type(odd) {
  background: none !important;
}
.VueCarousel-dot-container, .VueCarousel-dot {
  margin-top: 0px !important;
}
</style>